import { StationsState } from '../../types';

export const resetSelectedStationOnMap = (
  state: StationsState
) => ({
  ...state,
  selectedStationOnMap: undefined
});
